import styled from 'styled-components'

export const RecipeProductContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.875rem;
  padding: 0.875rem;

  width: 100%;

  @media (min-width: 1024px) {
    align-items: center;
    gap: 1.375rem;
    padding: 1.375rem;
  }
`

export const ProductMainInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-width: 0;
`

export const StrikethroughPrice = styled.span`
  text-decoration: line-through;
  margin-right: 0.35rem;
`

export const DiscountBadge = styled.span`
  font-weight: 600;
  color: ${({ theme }) => theme.colors?.primary?.[700] ?? '#748351'};
`
